import { createContext } from "react";
import { State, StoreActions } from "store/store-types";

const initialState: State = {};
const initialSetState: StoreActions = {};

export const BookingStateContext = createContext(initialState);
export const BookingSetStateContext = createContext(initialSetState);
